import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/es/storage'
import scoreTypesSlice from '../reducers/scoreTypes.slice'

const persistConfig = {
  key: 'scoreTypesSlice',
  storage,
}

export const persistedScoreTypesReducer = persistReducer(persistConfig, scoreTypesSlice)